import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CmsService, ContentSlotComponentData, PageType } from '@spartacus/core';
import { OutletModule, PageComponentModule } from '@spartacus/storefront';

@Component({
  selector: 'wc-free-content-cgv-page',
  templateUrl: './free-content-cgv-page.component.html',
  standalone: true,
  imports: [
    OutletModule,
    PageComponentModule
  ]
})
export class FreeContentCgvPageComponent implements OnInit {
  components: ContentSlotComponentData[];

  constructor(private cmsService: CmsService, private cdRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.cmsService.getPage({ id: '/popin/termsofsale', type: PageType.CONTENT_PAGE }).subscribe((page) => {
      this.components = page.slots['DynamicBody']?.components;
      this.cdRef.markForCheck();
    });
  }
}
